/**
 * Mapping of category names to URL-friendly slugs
 */
const CATEGORY_SLUG_MAP: Record<string, string> = {
  'Phone cases': 'phone-cases',
};

/**
 * Reverse mapping of slugs to category names
 */
const SLUG_CATEGORY_MAP: Record<string, string> = Object.fromEntries(
  Object.entries(CATEGORY_SLUG_MAP).map(([name, slug]) => [slug, name])
);

/**
 * Converts a category name to a URL-friendly slug
 * Example: "Чохли на телефон" -> "chokhly-na-telefon"
 */
export const categoryNameToSlug = (categoryName: string): string => {
  // First try to find in mapping
  if (CATEGORY_SLUG_MAP[categoryName]) {
    return CATEGORY_SLUG_MAP[categoryName];
  }

  // Fallback to automatic conversion
  return categoryName
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritics
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .trim()
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-'); // Replace multiple hyphens with single hyphen
};

/**
 * Converts a slug back to a category name
 */
export const slugToCategoryName = (slug: string): string | null => {
  // First try to find in mapping
  if (SLUG_CATEGORY_MAP[slug]) {
    return SLUG_CATEGORY_MAP[slug];
  }

  return null;
};
